import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "checkbox"]

  toggle() {
    const show = this.checkboxTarget.checked
    this.inputTargets.forEach(input => {
      input.type = show ? "text" : "password"
    })
  }
}
